export default {
	jobApplications : (state) => state.jobApplications,
	talents : (state) => state.talents,
	employees : (state) => state.employees,
	employers : (state) => state.employers,
	articles : (state) => state.articles,
	specializations : (state) => state.specializations,
	positionLevels : (state) => state.positionLevels,
	industries : (state) => state.industries,
	dressCodes : (state) => state.dressCodes,
	companySizes : (state) => state.companySizes,
	jobTypes : (state) => state.jobTypes,
	spokenLanguages : (state) => state.spokenLanguages,
	qualifications : (state) => state.qualifications,
	fetchCompanySizes : (state) => state.companySizes,
	pushNotifications : (state) => state.pushNotifications,
	creditPackageTransactions : (state) => state.creditPackageTransactions,
	employerStaticContents : (state) => state.employerStaticContents,
	candidateStaticContents : (state) => state.candidateStaticContents,
	countries : (state) => state.countries,
	states: (state) => state.states,
	dressCodesList : (state) => state.dressCodesList,
	industriesList : (state) => state.industriesList,
	companySizesList : (state) => state.companySizesList,
	spokenLanguagesList : (state) => state.spokenLanguagesList,
	appVersions : (state) => state.appVersions,
	pendingEmployers : (state) => state.pendingEmployers,
	employerFaqs : (state) => state.employerFaqs,
	candidateFaqs : (state) => state.candidateFaqs,
	companies : (state) => state.companies,
	jobApplicationsByUserId : (state) => state.jobApplicationsByUserId,
	creditPackages : (state) => state.creditPackages,
	jobAdvertisements : (state) => state.jobAdvertisements,
	jobAdvertisementsByCompanyId : (state) => state.jobAdvertisementsByCompanyId,
	specializationsList : (state) => state.specializationsList,
	activeCreditPackages : (state) => state.activeCreditPackages
};